import { withSuspenseBoundary } from '@/components';
import {
  InteractiveMapFormFields,
  InteractiveMapLayer,
  useInteractiveMapControlsContext,
} from '@/pages/shared/plots/pages/hooks/useControlsForm';

import { HabitatIntactnessLayers } from './HabitatIntactnessLayers';

export const InteractiveMapLayers = withSuspenseBoundary(() => {
  const controlsForm = useInteractiveMapControlsContext();
  const indicatorLayer = controlsForm.watch(InteractiveMapFormFields.IndicatorLayer);

  return <>{indicatorLayer === InteractiveMapLayer.HabitatIntactness && <HabitatIntactnessLayers />}</>;
}, null);
